import React from "react";
import { styled } from "@mui/system";

const FocusCornersContainer = styled("div")({
  "--corner-color": "#fff",
  "--corner-size": "10px",
  "--corner-margin": "0px",
  "--corner-thickness": "1px",
  position: "relative",
  width: "100%",
  height: "inherit",
  minHeight: "inherit",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&.with-border": {
    border: "0.5px solid currentColor"
  }
});

const Corner = styled("div")({
  position: "absolute",
  width: "var(--corner-size)",
  height: "var(--corner-size)",
  borderColor: "var(--corner-color)",
  transition: "transform 300ms",
  zIndex: 20,
  "&.top-left-corder": {
    left: 0,
    top: 0,
    transform: "translate(var(--corner-margin), var(--corner-margin))",
    borderLeftWidth: "var(--corner-thickness)",
    borderTopWidth: "var(--corner-thickness)",
    borderLeftStyle: "solid",
    borderTopStyle: "solid"
  },
  "&.top-right-corder": {
    top: 0,
    right: 0,
    transform: "translate(calc(-1 * var(--corner-margin)), var(--corner-margin))",
    borderRightWidth: "var(--corner-thickness)",
    borderTopWidth: "var(--corner-thickness)",
    borderRightStyle: "solid",
    borderTopStyle: "solid"
  },
  "&.bottom-left-corder": {
    bottom: 0,
    left: 0,
    transform: "translate(var(--corner-margin), calc(-1 * var(--corner-margin)))",
    borderLeftWidth: "var(--corner-thickness)",
    borderBottomWidth: "var(--corner-thickness)",
    borderLeftStyle: "solid",
    borderBottomStyle: "solid"
  },
  "&.bottom-right-corder": {
    bottom: 0,
    right: 0,
    transform: "translate(calc(-1 * var(--corner-margin)), calc(-1 * var(--corner-margin)))",
    borderRightWidth: "var(--corner-thickness)",
    borderBottomWidth: "var(--corner-thickness)",
    borderRightStyle: "solid",
    borderBottomStyle: "solid"
  }
});

const FocusCorners = ({ children, withBorder }) => {
  return (
    <FocusCornersContainer className={withBorder ? "with-border focus-corners" : " focus-corners"}>
      <Corner className="corner top-left-corder" />
      <Corner className="corner top-right-corder" />
      <Corner className="corner bottom-left-corder" />
      <Corner className="corner bottom-right-corder" />
      {children}
    </FocusCornersContainer>
  );
};

export default FocusCorners;
